// src/app/services/report.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ReportService {
  getLeadAgeingReport(counsellors: string[], fromDate: string | null, toDate: string | null,
    page: number, size: number) {
    const body = {
      counsellorIds: counsellors,
      fromDate: fromDate,
      toDate: toDate,
      page: page,
      size: size
    };

    return this.http.post<any>(
      `${this.baseUrl}/getLeadAgeingReport?page=${page}&size=${size}`,
      body
    );
  }

  private baseUrl = environment.serviceRoot;

  constructor(private http: HttpClient) { }

  getCounsellorPerformance(counsellors: string[], fromDate: string | null, toDate: string | null,
    page: number, size: number) {
    const body = {
      counsellorIds: counsellors,
      fromDate: fromDate,
      toDate: toDate,
      page: page,
      size: size
    };

    return this.http.post<any>(
      `${this.baseUrl}/getCounsellorPerformance?page=${page}&size=${size}`,
      body
    );
  }

  getCounsellorAndStudentWiseFollowUps(counsellors: string[], students: string[], fromDate: string | null, toDate: string | null,
    page: number, size: number) {
    const body = {
      counsellorIds: counsellors,
      studentsRefNo: students,
      fromDate: fromDate,
      toDate: toDate,
      page: page,
      size: size
    };

    return this.http.post<any>(
      `${this.baseUrl}/getCounsellorAndStudentWiseFollowUps?page=${page}&size=${size}`,
      body
    );
  }

  getLeadJourney(counsellors: string[], students: string[], fromDate: string | null, toDate: string | null,
    page: number, size: number) {
    const body = {
      counsellorIds: counsellors,
      studentsRefNo: students,
      fromDate: fromDate,
      toDate: toDate,
      page: page,
      size: size
    };

    return this.http.post<any>(
      `${this.baseUrl}/getLourneyByCounsellorAndStudents?page=${page}&size=${size}`,
      body
    );
  }

}
